import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { replaceStrValues } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';

const yesNoOptions = { hint: null, labelHeaderLevel: '' };

export const insuranceArrayOptions = {
  arrayPath: 'providers',
  nounPlural: content['insurance-info--array-noun-plural'],
  nounSingular: content['insurance-info--array-noun-singular'],
  required: false,
  text: {
    getItemName: item => item?.insuranceName || '—',
    cardDescription: item =>
      replaceStrValues(
        content['insurance-info--card-description'],
        item?.insurancePolicyHolderName || '—',
      ),
    cancelAddTitle: content['insurance-info--array-cancel-add-title'],
    cancelEditTitle: content['insurance-info--array-cancel-edit-title'],
    cancelEditDescription:
      content['insurance-info--array-cancel-edit-description'],
    cancelEditReviewDescription:
      content['insurance-info--array-cancel-edit-review-description'],
    cancelAddYes: content['insurance-info--array-cancel-add-yes'],
    cancelEditYes: content['insurance-info--array-cancel-edit-yes'],
    summaryTitle: content['insurance-info--summary-review-title'],
    summaryTitleWithoutItems: content['insurance-info--summary-title'],
  },
};

export default {
  uiSchema: {
    'view:hasHealthInsuranceToAdd': arrayBuilderYesNoUI(
      insuranceArrayOptions,
      yesNoOptions,
      yesNoOptions,
    ),
  },
  schema: {
    type: 'object',
    required: ['view:hasHealthInsuranceToAdd'],
    properties: {
      'view:hasHealthInsuranceToAdd': arrayBuilderYesNoSchema,
    },
  },
};
